// declare module '@inertiajs/inertia-react' {
//     export function InertiaHead({ children, title }: {children?: any, title?: string})
// }

import { InertiaHead } from '@inertiajs/inertia-react';

const Head = InertiaHead;

export default Head;
